import type React from 'react'
import Tooltip from '../../../../../../components/Tooltip'
import type {
  SwapStatus,
  TransferStatus,
} from '../../../../../../types/coreApi-types'

// Updated to support both TransferStatus and SwapStatus

interface StatusBoxProps {
  onClick: () => void
  isActive: boolean
  transferStatus: TransferStatus | SwapStatus
  disabled?: boolean
}

const StatusBox: React.FC<StatusBoxProps> = ({
  transferStatus,
  onClick,
  isActive,
  disabled,
}) => {
  const getClassName = () => {
    switch (transferStatus) {
      // Legacy TransferStatus values
      case 'Pending':
        return 'status-badge-pending '
      case 'UnderReview':
        return 'status-badge-info'
      case 'Processing':
        return 'status-badge-processing'
      case 'Completed':
        return 'status-badge-success'
      case 'Cancelled':
        return 'status-badge-cancelled'
      // SwapStatus values
      case 'Review':
        return 'status-badge-info'
      case 'DepositPending':
        return 'status-badge-pending'
      case 'DepositReceived':
        return 'status-badge-info'
      case 'WithdrawPending':
        return 'status-badge-processing'
      case 'OnHold':
        return 'status-badge-cancelled'
      case 'Rejected':
        return 'status-badge-cancelled'
      default:
        return ''
    }
  }

  const getDisplayText = () => {
    switch (transferStatus) {
      // Legacy TransferStatus values
      case 'UnderReview':
        return 'Under Review'
      // SwapStatus values
      case 'Review':
        return 'Review'
      case 'DepositPending':
        return 'Deposit Pending'
      case 'DepositReceived':
        return 'Deposit Received'
      case 'WithdrawPending':
        return 'Withdraw Pending'
      case 'OnHold':
        return 'On Hold'
      case 'Rejected':
        return 'Rejected'
      default:
        return transferStatus
    }
  }

  return (
    <div
      className="col-span-1"
      onClick={!isActive && !disabled ? onClick : undefined}
    >
      <Tooltip
        label={
          isActive
            ? 'This transaction is here now'
            : `Move to ${getDisplayText()}`
        }
      >
        <div
          className={`${getClassName()} w-full h-[60px] rounded-lg flex items-center justify-center cursor-pointer ${
            isActive ? 'border-solid border-[2px] border-black' : ''
          } ${disabled ? 'grayscale-[50%] cursor-not-allowed' : ''}`}
        >
          <div className="h-full flex items-center justify-center text-center">
            {getDisplayText()}
          </div>
        </div>
      </Tooltip>
    </div>
  )
}

export default StatusBox
